module.exports = __webpack_public_path__ + "img/multiplication-and-division-math-magic-tip2.43f4c546.png";